module.exports = __webpack_public_path__ + "static/media/CarDark.0d2f8993.svg";